import { endpoints } from 'modules/endpoints'
import { ApiService } from 'service/api/interface'
import { SkuOrderEntry, CalculateDiscountResponseSku } from './types'

export const fetchSkuIncentivePrograms = (apiClient: ApiService) => (params: SkuOrderEntry) => {
  return apiClient.post<CalculateDiscountResponseSku>(endpoints.incentivePrograms('sku'), params)
}
